<template>
  <div v-if="text" class="my-3">
    <div :class="['text-body-2 ', error ? 'error--text' : 'text--secondary']">
      {{ title }}
    </div>
    <div :class="['text-body-1', error ? 'error--text' : 'text--primary']">
      {{ text }}
    </div>
  </div>
</template>
<script>
export default {
  name: "AILine",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
